"use client";

import { Badge } from "@/app/_module/components/ui/badge";

interface ErsContactStatusBadgeProps {
  type: "sms" | "reply";
  status: string;
}

const SMS_STATUS_CONFIG: Record<string, { label: string; variant: string; className: string }> = {
  pending: { label: "Pending", variant: "secondary", className: "bg-gray-100 text-gray-600" },
  sent: { label: "Sent", variant: "default", className: "bg-blue-100 text-blue-700" },
  delivered: { label: "Delivered", variant: "default", className: "bg-green-100 text-green-700" },
  failed: { label: "Failed", variant: "destructive", className: "bg-red-100 text-red-700" },
  opted_out: { label: "Opted Out", variant: "secondary", className: "bg-orange-100 text-orange-700" },
};

const REPLY_STATUS_CONFIG: Record<string, { label: string; variant: string; className: string }> = {
  no_reply: { label: "No Reply", variant: "secondary", className: "bg-gray-100 text-gray-500" },
  replied: { label: "Replied", variant: "default", className: "bg-blue-100 text-blue-700" },
  converted: { label: "Converted", variant: "default", className: "bg-green-100 text-green-700" },
  declined: { label: "Declined", variant: "destructive", className: "bg-red-100 text-red-700" },
};

export function ErsContactStatusBadge({ type, status }: ErsContactStatusBadgeProps) {
  const config = type === "sms" ? SMS_STATUS_CONFIG : REPLY_STATUS_CONFIG;
  const statusConfig = config[status] || config.pending || config.no_reply;

  return (
    <Badge variant="outline" className={`text-xs font-medium ${statusConfig.className}`}>
      {statusConfig.label}
    </Badge>
  );
}
